import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import moment from "moment";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAddAppointment = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error adding appointment");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({
      id,
      patientId,
      startDate,
      startTime,
      durationInMins,
      practiceServiceId,
      locationId,
      reasonDescription,
      staffMemberId,
      consultationType,
      telephoneNumber,
      email,
    }) => {
      const startTimeApt = moment(startDate + " " + startTime).format(
        "YYYY-MM-DD HH:mm"
      );
      const endTimeApt = moment(startDate + " " + startTime)
        .add(Number(durationInMins), "minutes")
        .format("YYYY-MM-DD HH:mm");

      const startAtApt = moment(startTimeApt).format("HH:mm");
      const endAtApt = moment(endTimeApt).format("HH:mm");

      const data = {
        id,
        tenant: Number(tenantVal),
        patientId: Number(patientId),
        patient: {
          id: Number(patientId),
          tenant: Number(tenantVal),
        },
        startAt: startAtApt,
        endAt: endAtApt,
        startTime: startTimeApt,
        endTime: endTimeApt,
        practiceServiceId: practiceServiceId,
        practiceService: {
          id: practiceServiceId,
          tenant: Number(tenantVal),
        },
        locationId: locationId != null ? Number(locationId) : undefined,
        reasonDescription: reasonDescription,
        staffMemberId: Number(staffMemberId),
        durationInMins: durationInMins,
        consultationType: consultationType || "IN_PERSON",
        telephoneNumber: telephoneNumber,
        email: email,
      };

      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/appointment`,
        data
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["appointments"] });
      await queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      toast.success("Appointment added successfully!");
      onSuccess?.();
    },
    onError: handleNetworkError,
    // This hook shows its own specific "Error adding appointment" toast via
    // handleNetworkError, so opt out of the generic global mutation toast to
    // avoid a duplicate error toast on failure.
    meta: { skipGlobalError: true },
  });
};
